import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserOrderInfo, PickupTypeMetadata } from '@core/redux/stores';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { ProxyService, ModalService, OverlayService, ConfirmModalService, ErrorCodesService } from '@core/services';
import { TimePicker } from '@features/ordering/models';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import * as Store from '@core/redux/stores';
import { NgRedux } from '@angular-redux/store';
import { Actions, IAppState, ChildRecipeEntity } from '@core/redux/stores';
import { Router } from '@angular/router';
import * as _ from 'lodash-es';
import { PickupTimeService } from '@features/ordering/services/pickup-time.service';
import { CheckTimeUtility } from '@features/ordering/utilties/check-time-utility';
import { OrderDetails } from '@features/ordering/models/order-details.model';
import { LoggingService } from '@core/services/logging.service';
import * as moment from 'moment-timezone';
import { LocationConstants } from '@app/features/location/constants';
import { OrderStatus, OrderTriggerType } from '../../utilties/enums/order-status.utilities';
export enum ChangeTimeErrorCodes {
  DriveThruAvailAtPickupTime = 8530,
  DineInOrTakeOutAvailAtPickupTime = 8529,
  PickupTypeNotAvailAtPickupTime = 8540
}

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.less']
})
export class TimePickerComponent implements OnInit, OnDestroy {
  @select(appState => appState.submittedOrder) submittedOrder: Observable<UserOrderInfo>;
  @select((appState) => appState.auth.isLoggedIn)
  isLoggedIn?: Observable<boolean>;

  protected location: Store.LocationsEntity;
  public timepickerList: TimePicker[] = [];
  public originalList: TimePicker[] = [];
  public selectedTime: TimePicker;
  protected order: UserOrderInfo;
  protected isUserLoggedIn: boolean;
  protected recipes: Store.MealRecipe[] = [];
  protected childrec: Store.ChildRecipeEntity[] = [];
  protected orderDetails: OrderDetails;
  protected childRecipeList: Store.MealRecipe[] = [];
  protected childRecipeIds = '';
  protected pickupTimeUtc: string;
  protected orderTotal: number | null;
  public isLoading: boolean;
  private subscriptions = new Subscription();
  private time: string;
  private pickupTypeMetadata: Store.PickupTypeMetadata[];

  constructor(private proxy: ProxyService, private modalService: ModalService,
    private overlayService: OverlayService, private ngRedux: NgRedux<IAppState>,
    private router: Router, private pickupTimeService: PickupTimeService,
    private logger: LoggingService,
    private confirmModalService: ConfirmModalService) {
    this.isLoading = true;
    this.submittedOrder.subscribe(succ => {
      this.order = _.cloneDeep(succ) as UserOrderInfo;
    });
    this.isLoggedIn.subscribe(
      (auth) => {
        this.isUserLoggedIn = auth ? auth : false;
      });
    this.subscriptions.add(
      this.confirmModalService.btnEvent.subscribe((data: string) => {
        if (this.pickupTypeMetadata.find(p => p.text === data) || data === 'changeTime') {
          this.handleTimeChange(data);
        } else if (data === 'cancelTimePicker') {
          this.isLoading = false;
        }
      })
    );
    this.pickupTypeMetadata = LocationConstants.PickupTypeMetaDataList;
  }

  ngOnInit() {
    if (!this.isUserLoggedIn) {
      this.getGuestOrder();
    } else {
      if (this.order) {
        let recipeIds = '';
        this.order.recipes.forEach(childrec => {
          recipeIds += childrec.recipeId + ',';
        });
        this.getChildRecipies(recipeIds);
      }
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getGuestOrder() {
    if (!this.isUserLoggedIn) {
      this.proxy.httpGet('/meals/orders/' + this.order.orderNumber + '/guestuser/' + this.order.guid).subscribe(resp => {
        if (resp.body) {
          const success = <any>resp.body;
          this.isLoading = false;
          this.orderDetails = <OrderDetails>success;
          this.childRecipeList = <Store.MealRecipe[]>success.recipes;
          this.childRecipeIds = '';
          this.location = <Store.LocationsEntity>success.location;
          this.childRecipeList.forEach(childRecipe => {
            this.childRecipeIds += childRecipe.recipeId + ',';
          });
          this.getChildRecipies(this.childRecipeIds);
        }
      });
    }
  }
  setDefaultSelectedTime() {
    const defaultSelectedTime = this.timepickerList.find(r => !r.isImmediate && r.isSelectable);
    this.selectedTime = defaultSelectedTime;
  }

  //Serve-window filters: ASAP via store now when flag on; scheduled slots must finish by ServeEndTime.
  private applyServeTimeFilters(childRecipes: ChildRecipeEntity[]): void {
    const timeZone = this.order.location.timeZone;
    const isAsapAvailable = this.timepickerList.some(t => t.isImmediate);
    const allowOrdersThroughServeEndTime = !!this.order.location.allowOrdersThroughServeEndTime;

    childRecipes
      .filter(c => c.recipeBasicInfo?.startTime || c.recipeBasicInfo?.endTime || c.startTime || (c as any).endTime)
      .forEach(recipe => {
        this.timepickerList = CheckTimeUtility.filterTimePickersByServeWindow(
          this.timepickerList,
          recipe.recipeBasicInfo?.startTime || recipe.startTime,
          recipe.recipeBasicInfo?.endTime || (recipe as any).endTime,
          timeZone,
          isAsapAvailable,
          allowOrdersThroughServeEndTime
        );
      });

    const modifierGroupWithServeRestrictions = childRecipes
      .find(c => c.modifierGroupsWithServeRestrictions?.length)?.modifierGroupsWithServeRestrictions[0];
    if (modifierGroupWithServeRestrictions) {
      this.timepickerList = CheckTimeUtility.filterTimePickersByServeWindow(
        this.timepickerList,
        modifierGroupWithServeRestrictions.serveStartTime,
        modifierGroupWithServeRestrictions.serveEndTime,
        timeZone,
        isAsapAvailable,
        allowOrdersThroughServeEndTime
      );
    }
  }

  getChildRecipies(recipeIds): any {
    console.log('ORDER: ', this.order);
    const apiEndpoint = ApiRoutes.LOCATIONS + '/' + this.order.location.id +
      ApiRoutes.CHILD_RECIPE + '/?Ids=' + recipeIds;
    this.proxy.httpGet(apiEndpoint).subscribe(response => {
      this.isLoading = false;
      const result = <any>response.body;
      if (result) {
        const childRecipes = <ChildRecipeEntity[]>result.recipes;
        console.log('ORDER: ', this.order);
        this.pickupTimeService.getTime(this.order.location.id, this.order.subTotal + '&selectedPickupType='
          + this.order.pickupType).subscribe(
            resp => {
              this.isLoading = false;
              const success = <TimePicker[]>resp.body;
                this.timepickerList = success;


              if (this.timepickerList.length > 1 || this.timepickerList) {
                const timeFromList = this.timepickerList[0];
                  this.time = timeFromList.displayTimeRange;
              }

              this.applyServeTimeFilters(childRecipes);
              let selected = false;
              this.timepickerList.forEach(time => {
                time.displayTimeRange = time.prefix + ' ' + time.displayTimeRange + ' ' + time.suffix;
                if (time.isSelectable && !selected && !time.isImmediate) {
                  this.selectedTime = time;
                  selected = true;
                }
              });
              this.setDefaultSelectedTime();
            });
      }
    });
  }

  updateOrder(fallback: PickupTypeMetadata) {
    this.confirmModalService.show(
      `You have selected a ${fallback.text} only pickup time`,
      '',
      'You may change your pickup method now',
      `Select ${fallback.text}`,
      '',
      'Cancel',
      true,
      fallback.text,
      '',
      'cancelTimePicker'
    );
  }
  handleTimeChange(data = 'changeTime', updateOrder = false) {
    const updatedPickupMethod = this.pickupTypeMetadata.find(p => p.text === data);
    this.pickupTimeUtc = '"' + this.selectedTime.startTimeUtc + '"';
    let route, navigateTo;
    if (this.isUserLoggedIn) {
      route = ApiRoutes.CHANGE_PICKUPTIME + this.order.orderNumber + '/pickup-time';
      navigateTo = '/ordering/orderstatus';
    } else {
      route = '/meals/orders/' + this.order.orderNumber + '/' + this.order.guid + '/pickup-time';
      navigateTo = '/ordering/orderstatus?returnUrl=/home';
    }
    if (data === 'changeTime') {
      route = route + '/' + this.order.pickupType.toString();
    } else if (updatedPickupMethod) {
      route = route + '/' + updatedPickupMethod.pickupType.toString();
    }
    if (this.selectedTime.isImmediate && route.indexOf('?') > -1) {
      route += '&isImmediate=' + this.selectedTime.isImmediate;
    } else if (this.selectedTime.isImmediate) {
      route += '?isImmediate=' + this.selectedTime.isImmediate;
    }
    if (data === 'changeTime' || updatedPickupMethod) {
      this.isLoading = true;
      this.proxy.httpPut(route,
        this.pickupTimeUtc).subscribe(
          success => {
            this.isLoading = false;
            console.log('SELECTED TIME: ', this.selectedTime);
            this.order.pickupDateTimeUtc = this.selectedTime.startTimeUtc;
            this.order.pickupTime = this.selectedTime.displayTimeRange;
            if (this.selectedTime.pickupType) {
              this.order.pickupType = this.selectedTime.pickupType;
            }
            if(this.selectedTime.isImmediate) {
              this.order.orderTriggerType = OrderTriggerType.Immediate;
            }
            this.ngRedux.dispatch({ type: Actions.SUBMITTEDORDER, data: this.order });
            this.overlayService.displayOverlay(
              'Your pickup time has been changed.'
            );
            this.modalService.hideModal();
          }, err => {
            const fallback = this.pickupTimeService.getFallbackPickupType(this.pickupTypeMetadata,
               this.selectedTime.availablePickupTypes, this.order.pickupType);
            if ((err.error.code in ChangeTimeErrorCodes) && updateOrder && fallback) {
              this.updateOrder(fallback);
            } else {
              this.overlayService.displayOverlay('Your pickup time can\'t be changed.');
              this.modalService.hideModal();
            }
          });
    }

    this.router.navigateByUrl(navigateTo);
  }
  changeTime(selectedTime) {
    this.handleTimeChange('changeTime', true);
  }
  cancel() {
    this.modalService.hideModal();
  }
}
